/**
 * @ngdoc directive
 * @module components.carousel
 * @name components.carousel:carouselNav
 * @scope
 * @restrict E
 * @description
 * Generates a set of buttons that used to change the current slide of the attached carousel. Must be nested beneath a (carousel-sync)[/docs/api/components.carousel:carouselSync] tag to function.
 * @param {array} slides Same array that is passed to its associated carousel. Used to generate a matching number of buttons.
 * @example
        <example module="dataExample">
            <file name="index.html">
                <div ng-controller="exampleController">
                    <carousel-sync>
                        <carousel slides="slides">
                            <slide>
                                <h3>{{slide.name}}</h3>
                                <div ng-bind-html="slide.summary"></div>
                            </slide>
                        </carousel>
                        <carousel-nav slides="slides"></carousel-nav>
                    </carousel-sync>
                </div>
            </file>
            <file name="script.js">
                (function() {
                    angular.module('dataExample', ['components.carousel'])
                        .controller('exampleController', exampleController);

                    exampleController.$inject = ['$scope'];
                    function exampleController($scope) {
                        $scope.slides = [];
                        for (var i=0; i<5; i++) {
                            $scope.slides.push({
                                name: 'Slide ' + i,
                                summary: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu pharetra ex. Curabitur eu nunc id dolor laoreet consectetur nec ornare elit. Vivamus elementum turpis ac mi vehicula fermentum. Morbi eget neque justo. Cras id elit condimentum felis vehicula suscipit. Maecenas sagittis pulvinar ante, eu cursus justo placerat ac. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam lacus leo, tristique eu nunc a, placerat placerat tortor. Fusce eget consectetur ante. Suspendisse lobortis dui libero. In ac libero vel eros ultricies auctor nec in felis. Vestibulum sed odio orci.</p><p>Curabitur pellentesque lobortis dui, et luctus ex convallis id. Cras scelerisque augue at imperdiet placerat. In diam velit, congue at diam ut, iaculis feugiat turpis. Donec id elit id elit vestibulum semper. Curabitur quis neque quis ipsum ultricies tincidunt vitae varius lectus. Proin at erat vestibulum, hendrerit urna ac, cursus mi. Cras pulvinar at felis vitae gravida. Nunc egestas rhoncus felis, vel vestibulum nisl condimentum quis. Vestibulum quis iaculis elit.</p>'
                            });
                        }
                    }
                })();
            </file>
        </example>
 */
(function () {
	angular.module('components.carousel')
		.component('carouselNav', {
		    bindings: {
		        slides: '<',
		        slideCount: '<'
		    },
			require: {
				'carouselSync': '^carouselSync'
			},
			template: '<a ng-click="$ctrl.carouselSync.updateCarousels($index, $ctrl.carouselSync)" ng-repeat="item in $ctrl.slides" ng-class="{active: $index === $ctrl.index}"></a>',
			//template: '<a ng-click="$ctrl.carouselSync.updateCarousels($index * $ctrl.slides.length, $ctrl.carouselSync)" ng-repeat="item in $ctrl.navs" ng-class="{active: $index === $ctrl.index}"></a>',
			controller: carouselNavController
		});

	carouselNavController.$inject = ['$scope', 'utility'];
	function carouselNavController($scope, utility) {
	    var ctrl = this;
	    ctrl.navs = [];
	    ctrl.$onInit = function () {
	        if (ctrl.slides) {
	            var slideCount = utility.getResponsiveValue(ctrl.slideCount);
	            var totalNavs = Math.ceil(ctrl.slides.length / parseFloat(slideCount));
	            for (var i = 1; i <= totalNavs; i++) {
	                ctrl.navs.push({ nav: i });
	            }
	        }

			ctrl.index = 0;
			ctrl.carouselIndex = ctrl.carouselSync.registerCarousel(ctrl);
		}

		ctrl.goToSlide = function (index) {
		    $scope.$evalAsync(function () {
		        ctrl.index = index;
		    });
		}
	}
})();